import { __assign } from "tslib";
import * as React from 'react';
function IconEyeCloseSizeXs(props) {
    return (React.createElement("svg", __assign({ viewBox: "0 0 12 12" }, props),
        React.createElement("path", { clipRule: "evenodd", d: "M1 9.485l.707.707 8.485-8.485L9.485 1 8.132 2.353A6.557 6.557 0 006 2C3.273 2 .944 3.659 0 6a6.348 6.348 0 001.915 2.57L1 9.485zM3.475 7.01l3.5-3.5A2.773 2.773 0 006 3.332C4.495 3.333 3.273 4.528 3.273 6c0 .357.072.698.202 1.01zm4.987-2.158l1.51-1.51A6.353 6.353 0 0112 6c-.944 2.341-3.273 4-6 4a6.55 6.55 0 01-2.28-.406l1.161-1.162c.342.15.72.235 1.119.235 1.505 0 2.727-1.195 2.727-2.667 0-.411-.095-.8-.265-1.148z" })));
}
export default IconEyeCloseSizeXs;
